export default __webpack_public_path__ + "static/media/Padron1926.1495c05b.png";